import { useQuery } from '@tanstack/react-query';
import { fetchUrgencyCodesList } from '@views/screens/common/data-provider/urgency-codes-list';

export const useGetUrgencyCodesList = () => {
  return useQuery({
    queryKey: ['urgency-codes-list'],
    queryFn: () => fetchUrgencyCodesList(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
